// extracted by mini-css-extract-plugin
export var container = "searchItem-module--container--7e30b flex items-center group hover_bg-light";
export var image = "searchItem-module--image--66363 object-cover w-full h-full";
export var imageContainer = "searchItem-module--imageContainer--c2213 w-ms6 h-ms6 mr-ms1";
export var link = "searchItem-module--link--9ff20 group_hover_text-primary transition duration-300 ease-in-out";